import React, {useContext, useEffect, useState} from "react";
import {Box, Button, Dialog, DialogActions, DialogContent, Grid, IconButton, Stack} from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContentText from "@mui/material/DialogContentText";
import {EditRounded} from "@mui/icons-material";
import {useTranslation} from "react-i18next";
import {useRecoilState} from "recoil";
import {AxiosError} from "axios";
import { useForm, FormProvider } from "react-hook-form";
import {SET_SNACKBAR} from "../../../common/utils";
import {GlobalContext} from "../../../../../util/state/GlobalContextProvider";
import {ALL_COUNTRIES_PREFIX, CountryType} from "../../../data";
import { generalInfoState } from "../../../search-dms/state";
import { updateGeneralInfo} from "../../../search-dms/dmsSearch.actions";
import {FormAutocomplete, FormTextField } from "../../../common/form-fields-wrappers";
import {NetworkScope} from "../../../types";
import {useHasScope} from "../../../../../config/globalConfig";
import {DMS_LOCATION_TYPES} from "../data";

const mockDmsType = [
    'Real',
    'Shuttle',
    'Dealer',
    'Temporary',
    'Implant c/o company',
    'DMS self public area',
    'DMS private area',
    'White label',
    'Meet & Greet/ Virtual',
    'Site of interest'
];

const mockWhiteLabelList = [
    'JLR',
];

const mockDmsCategory = [
    'Car Rental',
    'Virtual',
    'Car Dealer',
    'Broker',
    'Repair shop',
    'Deposit provider',
    'Service',
];


const minutesToTime = (minutes: number) => {
    //console.log("minutesToTime --> keylessInfo: " + JSON.stringify(keylessInfo));

    if (isNaN(minutes) || typeof minutes !== 'number') {
        return "00:00";
    }

    const minutesPart = minutes % 60;
    const hoursPart = Math.floor(minutes / 60);

    // for format: hh:mm
    const formattedHours = String(hoursPart).padStart(2, '0');
    const formattedMinutes = String(minutesPart).padStart(2, '0');

    return `${formattedHours}:${formattedMinutes}`;
}

const GeneralInfo = (props:any) => {
    const {t} = useTranslation(["network", "translation"]);
    const { t :type } = useTranslation(['servicetype', 'translation']);
    const hasScope = useHasScope;
    const countriesPrefix:CountryType[] = ALL_COUNTRIES_PREFIX ;
    const [generalInfo,setGeneralInfo] = useRecoilState(generalInfoState);
    const [isWhiteLabelVisible, setIsWhiteLabelVisible]= useState(false);
    const { dispatchGlobalData } = useContext(GlobalContext);
    const generalInfoForm = useForm({
        defaultValues: {
            id: generalInfo?.id,
            bpKind: generalInfo?.bpKind ?? "",
            dmsCluster:  generalInfo?.dmsCluster ??  { code: '', description: '' },
            oldIdentificationCode:  generalInfo?.oldIdentificationCode ?? "",
            whiteLabelType: generalInfo?.whiteLabelType ?? "",
            serviceType: generalInfo?.serviceType ?? [],
            brandName: generalInfo?.brandName ?? "",
            city17: generalInfo?.city17 ?? "",
            postalCode: generalInfo?.postalCode ?? "",
            latitude: generalInfo?.latitude ?? "",
            longitude: generalInfo?.longitude ?? "",
            bubble: generalInfo?.bubble ?? "",
            phoneNumber: generalInfo?.phoneNumber ?? "",
            cellPhoneNumber: generalInfo?.cellPhoneNumber ?? "",
            fax: generalInfo?.fax ?? "",
            email: generalInfo?.email ?? "",
            branchManager: generalInfo?.branchManager ?? "",
            branchManagerCellPhoneNumber: generalInfo?.branchManagerCellPhoneNumber ?? "",
            area: generalInfo?.area ?? "",
            areaManager: generalInfo?.areaManager ?? "",
            prefixPhoneNumber: generalInfo?.prefixPhoneNumber ?? "",
            prefixCellPhoneNumber: generalInfo?.prefixCellPhoneNumber ?? "",
            prefixBranchManagerCellPhoneNumber: generalInfo?.prefixBranchManagerCellPhoneNumber ?? "",
            country: generalInfo?.country ?? "",
            name: generalInfo?.name ?? "",
            identificationCode: generalInfo?.identificationCode ?? "",
            sapId: generalInfo?.sapId ?? "",
            dmsType: generalInfo?.dmsType ?? "",
            dmsCategory:  generalInfo?.dmsCategory ?? [],
            currentStatus: generalInfo?.currentStatus ?? "",
            currentAttribute: generalInfo?.currentAttribute ?? "",
            region: generalInfo?.region ?? "",
            province: generalInfo?.province ?? "",
            city: generalInfo?.city ?? "",
            chargingColumnId: generalInfo?.chargingColumnId ?? "",
            address: generalInfo?.address ?? "",
            streetNumber: generalInfo?.streetNumber ?? "",
            companyName: generalInfo?.companyName ?? "",
            /*
            rce: generalInfo?.rce ? "Yes" : "No",
            rceMaxPreauth: minutesToTime(generalInfo?.rceMaxPreauth ?? 0),
            rcetmaxAssignedVehicle: minutesToTime(generalInfo?.rcetmaxAssignedVehicle ?? 0),
            */
        }
    });
    const onSubmit = (data: any) => {
        const reqParameters = {
            id: data.id,
            bpKind: data.bpKind,
            oldIdentificationCode: data.oldIdentificationCode,
            dmsCluster:  data.dmsCluster ,
            whiteLabelType: data.whiteLabelType ,
            serviceType: data.serviceType ,
            brandName: data.brandName ,
            city17: data.city17 ,
            postalCode: data.postalCode ,
            latitude: data.latitude ,
            longitude: data.longitude ,
            bubble: data.bubble,
            phoneNumber: data.phoneNumber ,
            cellPhoneNumber: data.cellPhoneNumber ,
            fax: data.fax ,
            email: data.email ,
            branchManager: data.branchManager,
            branchManagerCellPhoneNumber: data.branchManagerCellPhoneNumber ,
            area: data.area ,
            areaManager: data.areaManager ,
            // prefixPhoneNumber: {
            //     code: data.prefixPhoneNumber.code ,
            //     description: data.prefixPhoneNumber.description ,
            //     label: data.prefixPhoneNumber.label
            // },
            // prefixCellPhoneNumber: {
            //     code: data.prefixCellPhoneNumber.code ,
            //     description: data.prefixCellPhoneNumber.description ,
            //     label: data.prefixCellPhoneNumber.label
            // },
            // prefixBranchManagerCellPhoneNumber: {
            //     code: data.prefixBranchManagerCellPhoneNumber.code ,
            //     description: data.prefixBranchManagerCellPhoneNumber.description ,
            //     label: data.prefixBranchManagerCellPhoneNumber.label
            // },
            country: data.country ,
            name: data.name ,
            identificationCode: data.identificationCode ,
            sapId: data.sapId,
            dmsType: data.dmsType ,
            dmsCategory:  data.dmsCategory ,
            currentStatus: data.currentStatus ,
            currentAttribute: data.currentAttribute ,
            region: data.region ,
            province: data.province ,
            city: data.city ,
            chargingColumnId: data.chargingColumnId,
            address: data.address ,
            streetNumber: data.streetNumber ,
            companyName: data.companyName 
        }
        setOpen(false);
        setIsDisabled(true);
        updateGeneralInfo(reqParameters)
            .then( (res:any) => {
                setGeneralInfo(res.generalInfo);
            })
            .catch((err: AxiosError) => {
                dispatchGlobalData(SET_SNACKBAR.ERROR);
            });

    }
    const [isDisabled, setIsDisabled] = useState(true);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [open, setOpen] = useState(false);
    const handleDisableForm = (value:boolean) => {
        setIsDisabled(value);
    }
    const handleWhiteLabel = (e: React.SyntheticEvent, value: any) => {
        if(value === 'White label'){
            setIsWhiteLabelVisible(true);
        } else {
            setIsWhiteLabelVisible(false);
        }
    }

    useEffect(() => {
        if (!generalInfo) {
            return;
        }

        generalInfoForm.setValue("id",generalInfo?.id);
        generalInfoForm.setValue("dmsCluster",generalInfo?.dmsCluster);
        generalInfoForm.setValue("whiteLabelType",generalInfo?.whiteLabelType);
        generalInfoForm.setValue("serviceType",generalInfo?.serviceType);
        generalInfoForm.setValue("brandName",generalInfo?.brandName);
        generalInfoForm.setValue("city17",generalInfo?.city17);
        generalInfoForm.setValue("postalCode",generalInfo?.postalCode);
        generalInfoForm.setValue("latitude",generalInfo?.latitude);
        generalInfoForm.setValue("longitude",generalInfo?.longitude);
        generalInfoForm.setValue("bubble",generalInfo?.bubble);
        generalInfoForm.setValue("phoneNumber",generalInfo?.phoneNumber);
        generalInfoForm.setValue("cellPhoneNumber",generalInfo?.cellPhoneNumber);
        generalInfoForm.setValue("fax",generalInfo?.fax);
        generalInfoForm.setValue("email",generalInfo?.email);
        generalInfoForm.setValue("branchManager",generalInfo?.branchManager);
        generalInfoForm.setValue("branchManagerCellPhoneNumber",generalInfo?.branchManagerCellPhoneNumber);
        generalInfoForm.setValue("area",generalInfo?.area);
        generalInfoForm.setValue("areaManager",generalInfo?.areaManager);
        generalInfoForm.setValue("prefixPhoneNumber",generalInfo?.prefixPhoneNumber);
        generalInfoForm.setValue("prefixCellPhoneNumber",generalInfo?.prefixCellPhoneNumber);
        generalInfoForm.setValue("prefixBranchManagerCellPhoneNumber",generalInfo?.prefixBranchManagerCellPhoneNumber);
        generalInfoForm.setValue("country",generalInfo?.country);
        generalInfoForm.setValue("name",generalInfo?.name);
        generalInfoForm.setValue("identificationCode",generalInfo?.identificationCode);
        generalInfoForm.setValue("sapId",generalInfo?.sapId);
        generalInfoForm.setValue("dmsType",generalInfo?.dmsType);
        generalInfoForm.setValue("dmsCategory",generalInfo?.dmsCategory ?? []);
        generalInfoForm.setValue("currentStatus",generalInfo?.currentStatus);
        generalInfoForm.setValue("currentAttribute",generalInfo?.currentAttribute);
        generalInfoForm.setValue("region",generalInfo?.region);
        generalInfoForm.setValue("province",generalInfo?.province);
        generalInfoForm.setValue("city",generalInfo?.city);
        generalInfoForm.setValue("chargingColumnId",generalInfo?.chargingColumnId);
        generalInfoForm.setValue("address",generalInfo?.address);
        generalInfoForm.setValue("streetNumber",generalInfo?.streetNumber);
        generalInfoForm.setValue("companyName",generalInfo?.companyName);
        generalInfoForm.setValue("bpKind",generalInfo?.bpKind);
        generalInfoForm.setValue("oldIdentificationCode",generalInfo?.oldIdentificationCode);
        /*
        generalInfoForm.setValue("rce",generalInfo?.rce);
        generalInfoForm.setValue("rceMaxPreauth",generalInfo?.rceMaxPreauth);
        generalInfoForm.setValue("rcetmaxAssignedVehicle",generalInfo?.rcetmaxAssignedVehicle);
        */
    },[generalInfo])

    return(
        <>
                <FormProvider {...generalInfoForm}>
                        <Grid container direction="row" alignItems="start">
                            <Grid item xs={12}>
                                <Stack direction="column" spacing={2} justifyContent="flex-end" alignItems="flex-end">
                                    {hasScope(NetworkScope.MsMng) && isDisabled &&
                                        <IconButton color={"accent"} onClick={() => {handleDisableForm(props.handleDisabledForm)}}>
                                            <EditRounded/>
                                        </IconButton>
                                    }
                                </Stack>
                            </Grid>
                            <Grid container item direction="row" xs={12} columnSpacing={2}>
                                <Grid item xs={3}>
                                    <FormTextField
                                        disabled
                                        control={generalInfoForm.control}
                                        name="identificationCode"
                                        label={t("dmsDetail.generalInfo.form.label.identificationCode")}
                                    />

                                </Grid>

                                <Grid item xs={3}>
                                    <FormTextField
                                        disabled
                                        control={generalInfoForm.control}
                                        name="bpKind"
                                        label={t("dmsDetail.generalInfo.form.label.bpKind")}
                                    />

                                </Grid>

                                <Grid item xs={3}>
                                    <FormTextField
                                        disabled
                                        control={generalInfoForm.control}
                                        name="oldIdentificationCode"
                                        label={t("dmsDetail.generalInfo.form.label.oldIdentificationCode")}
                                    />

                                </Grid>

                                <Grid item xs={3}>
                                    <FormTextField
                                        disabled
                                        control={generalInfoForm.control}
                                        name="name"
                                        label={t("dmsDetail.generalInfo.form.label.dmsNaming")}
                                    />

                                </Grid>
                                <Grid item xs={3}>
                                    <FormTextField
                                        disabled
                                        control={generalInfoForm.control}
                                        name="sapId"
                                        label={t("dmsDetail.generalInfo.form.label.sapId")}
                                    />

                                </Grid>
                                <Grid item xs={3}>
                                    <FormTextField
                                        disabled
                                        control={generalInfoForm.control}
                                        name="currentStatus"
                                        label={t("dmsDetail.generalInfo.form.label.currentStatus")}
                                    />

                                </Grid>
                                <Grid item xs={3}>
                                    <FormTextField
                                        disabled
                                        control={generalInfoForm.control}
                                        name="currentAttribute"
                                        label={t("dmsDetail.generalInfo.form.label.currentAttribute")}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <FormAutocomplete
                                        disabled={isDisabled}
                                        control={generalInfoForm.control}
                                        name="dmsCluster"
                                        options={DMS_LOCATION_TYPES}
                                        label={t("dmsDetail.generalInfo.form.label.dmsCluster")}
                                        isOptionEqualToValue={(option, value) => option?.code === value?.code}
                                        getOptionLabel={(opt: any) => opt?.code ? t(`dmsDetail.generalInfo.form.label.dmsClusterOpt.${opt.code}`) : ""}
                                    />

                                </Grid>
                                <Grid item xs={3}>
                                    <FormAutocomplete
                                        disabled
                                        control={generalInfoForm.control}
                                        name="dmsType"
                                        options={mockDmsType}
                                        label={t("dmsDetail.generalInfo.form.label.dmsType")}
                                        getOptionLabel={(option) => option ? option : ''}
                                        onChange={handleWhiteLabel}
                                        onInputChange={handleWhiteLabel}
                                    />
                                </Grid>

                                {isWhiteLabelVisible ? <Grid item xs={3}>
                                    <FormAutocomplete
                                        disabled={isDisabled}
                                        control={generalInfoForm.control}
                                        name="whiteLabelType"
                                        options={mockWhiteLabelList}
                                        label={t("dmsDetail.generalInfo.form.label.whiteLabelType")}
                                        getOptionLabel={(option) => option ? option : ''}
                                    />
                                </Grid>: null}

                                <Grid item xs={3}>
                                    <FormAutocomplete
                                        disabled
                                        control={generalInfoForm.control}
                                        name="dmsCategory"
                                        multiple={true}
                                        options={mockDmsCategory}
                                        label={t("dmsDetail.generalInfo.form.label.dmsCategory")}
                                        getOptionLabel={(option) => option ? option : ''}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <FormAutocomplete
                                        disabled
                                        control={generalInfoForm.control}
                                        name="serviceType"
                                        multiple={true}
                                        options={mockDmsCategory}
                                        label={t("dmsDetail.generalInfo.form.label.serviceType")}
                                        getOptionLabel={(option) => option ? (
                                            option.includes('|')
                                                ? type(option.split('|')[0].replace(":", "-"))
                                                : option
                                        ) : ''}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <FormTextField
                                        disabled
                                        control={generalInfoForm.control}
                                        name="brandName"
                                        label={t("dmsDetail.generalInfo.form.label.brandName")}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <FormTextField
                                        disabled={isDisabled}
                                        control={generalInfoForm.control}
                                        name="city17"
                                        label={t("dmsDetail.generalInfo.form.label.cityCluster")}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <FormTextField
                                        disabled
                                        control={generalInfoForm.control}
                                        name="city"
                                        label={t("dmsDetail.generalInfo.form.label.city")}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <FormTextField
                                        disabled
                                        control={generalInfoForm.control}
                                        name="address"
                                        label={t("dmsDetail.generalInfo.form.label.address")}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <FormTextField
                                        disabled
                                        control={generalInfoForm.control}
                                        name="streetNumber"
                                        label={t("dmsDetail.generalInfo.form.label.streetNumber")}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <FormTextField
                                        disabled
                                        control={generalInfoForm.control}
                                        name="country"
                                        label={t("dmsDetail.generalInfo.form.label.country")}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <FormTextField
                                        disabled
                                        control={generalInfoForm.control}
                                        name="region"
                                        label={t("dmsDetail.generalInfo.form.label.region")}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <FormTextField
                                        disabled
                                        control={generalInfoForm.control}
                                        name="province"
                                        label={t("dmsDetail.generalInfo.form.label.province")}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <FormTextField
                                        disabled
                                        control={generalInfoForm.control}
                                        name="postalCode"
                                        label={t("dmsDetail.generalInfo.form.label.postalCode")}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <FormTextField
                                        disabled
                                        control={generalInfoForm.control}
                                        name="longitude"
                                        label={t("dmsDetail.generalInfo.form.label.longitude")}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <FormTextField
                                        disabled
                                        control={generalInfoForm.control}
                                        name="latitude"
                                        label={t("dmsDetail.generalInfo.form.label.latitude")}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <FormTextField
                                        disabled={isDisabled}
                                        control={generalInfoForm.control}
                                        name="bubble"
                                        label={t("dmsDetail.generalInfo.form.label.bubble")}
                                    />
                                </Grid>

                                <Grid item container xs={3} columnSpacing={2}>
                                    <Grid item xs={6}>
                                        <FormAutocomplete
                                            disabled
                                            control={generalInfoForm.control}
                                            name="prefixPhoneNumber"
                                            label={t("dmsDetail.generalInfo.form.label.prefix")}
                                            options={countriesPrefix}
                                            getOptionLabel={(option: any) => option?.code + " +" + option?.description}
                                            isOptionEqualToValue={(option, value) => option?.code === value?.code}
                                            renderOption={(props, option) => (
                                                <Box
                                                    component="li"
                                                    {...props}
                                                >
                                                    {option?.code} +{option?.description}
                                                </Box>
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <FormTextField
                                            disabled
                                            control={generalInfoForm.control}
                                            name="phoneNumber"
                                            label={t("dmsDetail.generalInfo.form.label.phone")}
                                        />
                                    </Grid>
                                </Grid>



                                <Grid item container xs={3} columnSpacing={2}>
                                    <Grid item xs={6}>
                                        <FormAutocomplete
                                            disabled
                                            control={generalInfoForm.control}
                                            name="prefixCellPhoneNumber"
                                            label={t("dmsDetail.generalInfo.form.label.prefix")}
                                            options={countriesPrefix}
                                            getOptionLabel={(option: any) => option?.code + " +" + option?.description}
                                            isOptionEqualToValue={(option, value) => option?.code === value?.code}
                                            renderOption={(props, option) => (
                                                <Box
                                                    component="li"
                                                    {...props}
                                                >
                                                    {option?.code} + {option?.description}
                                                </Box>
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <FormTextField
                                            disabled
                                            control={generalInfoForm.control}
                                            name="cellPhoneNumber"
                                            label={t("dmsDetail.generalInfo.form.label.cellPhoneNumber")}
                                        />
                                    </Grid>

                                </Grid>
                                <Grid item xs={3}>
                                    <FormTextField
                                        disabled
                                        control={generalInfoForm.control}
                                        name="fax"
                                        label={t("dmsDetail.generalInfo.form.label.fax")}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <FormTextField
                                        disabled
                                        control={generalInfoForm.control}
                                        name="email"
                                        label={t("dmsDetail.generalInfo.form.label.email")}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <FormTextField
                                        disabled
                                        control={generalInfoForm.control}
                                        name="branchManager"
                                        label={t("dmsDetail.generalInfo.form.label.branchManager")}
                                    />
                                </Grid>
                                <Grid item container xs={3} columnSpacing={2}>
                                    <Grid item xs={6}>
                                        <FormAutocomplete
                                            disabled
                                            control={generalInfoForm.control}
                                            name="prefixBranchManagerCellPhoneNumber"
                                            label={t("dmsDetail.generalInfo.form.label.prefixBranchManagerCellPhoneNumber")}
                                            options={countriesPrefix}
                                            getOptionLabel={(option: any) => option?.code + " +" + option?.description}
                                            isOptionEqualToValue={(option, value) => option?.code === value?.code}
                                            renderOption={(props, option) => (
                                                <Box
                                                    component="li"
                                                    {...props}
                                                >
                                                    {option?.code} +{option?.description}
                                                </Box>
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <FormTextField
                                            disabled
                                            control={generalInfoForm.control}
                                            name="branchManagerCellPhoneNumber"
                                            label={t("dmsDetail.generalInfo.form.label.branchManagerCellPhoneNumber")}
                                        />
                                    </Grid>

                                </Grid>
                                <Grid item xs={3}>
                                    <FormTextField
                                        disabled
                                        control={generalInfoForm.control}
                                        name="area"
                                        label={t("dmsDetail.generalInfo.form.label.area")}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <FormTextField
                                        disabled
                                        control={generalInfoForm.control}
                                        name="areaManager"
                                        label={t("dmsDetail.generalInfo.form.label.areaManager")}
                                    />
                                </Grid>
                                {/*<Grid item xs={3}>
                                    <FormTextField
                                        disabled
                                        control={generalInfoForm.control}
                                        name="rce"
                                        label={"Digital Only"}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <FormTextField
                                        disabled
                                        control={generalInfoForm.control}
                                        name="rceMaxPreauth"
                                        label={"RCE Max PreAuth"}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <FormTextField
                                        disabled
                                        control={generalInfoForm.control}
                                        name="rcetmaxAssignedVehicle"
                                        label={"RCE Tmax Assigned Vehicle"}
                                    />
                                </Grid>*/}
                                <Grid item xs={12}>
                                    <Stack direction="column" spacing={2} justifyContent="flex-end" alignItems="flex-end">
                                        { !isDisabled &&
                                            <Button variant="contained" onClick={handleOpen} >
                                                {t("dmsDetail.generalInfo.button.edit")}
                                            </Button>
                                        }
                                    </Stack>
                                </Grid>
                            </Grid>
                        </Grid>
                </FormProvider>

                <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {t("dmsDetail.generalInfo.dialog.title")}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {t("dmsDetail.generalInfo.dialog.content")}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}  variant={"outlined"} color={"accent"}>
                            {t("dmsDetail.generalInfo.dialog.action.cancel")}
                        </Button>
                        <Button onClick={generalInfoForm.handleSubmit(onSubmit)} autoFocus>
                            {t("dmsDetail.generalInfo.dialog.action.confirm")}
                        </Button>
                    </DialogActions>
                </Dialog>
        </>
    )
}

export default GeneralInfo;